export const SLCase = {
  CAMEL: 'camelCase',
  SNAKE: 'snake_case',
} as const;

export type SLCaseType = (typeof SLCase)[keyof typeof SLCase];
